import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';
import type { ReactNode } from 'react';
import type { Language, Translations } from './types';
import { es } from './translations/es';

const translations: Record<Language, Translations> = { es };

export const normalizeLanguage = (_code: string | undefined | null): Language => 'es';

interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: Translations;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

interface LanguageProviderProps {
  children: ReactNode;
  userLanguage?: string | null;
}

export const LanguageProvider: React.FC<LanguageProviderProps> = ({ children }) => {
  const [language] = useState<Language>('es');

  const setLanguage = useCallback((_lang: Language) => {}, []);

  const t = useMemo(() => translations[language], [language]);

  const value = useMemo(() => ({ language, setLanguage, t }), [language, setLanguage, t]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = (): LanguageContextType => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const useTranslation = () => {
  const { t } = useLanguage();
  return t;
};
